import { httpPost } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSelectSubscriptionPlan = async ({
  planGroupId,
  planId,
  customerId,
  lang,
}: {
  planGroupId: string;
  planId: string;
  customerId: string;
  lang: string;
}) => {
  const response = await httpPost<{
    data: PaymentDataResponse & { intent_secret?: string };
  }>(
    `subscriptions/embeds/${planGroupId}/?customer=${customerId}&plan=${planId}&lang=${lang}`
  );

  const moneyHashIntentSecret = response.data.intent_secret;
  return {
    ...formatPaymentResponse(response),
    moneyHashIntentSecret,
  };
};
